<vdr-affixed-input [suffix]="config?.ui?.suffix" [prefix]="config?.ui?.prefix">
  <input
    type="text"
    class="min-h-[36px] input"
    [attr.min]="config?.min"
    [attr.max]="config?.max"
    [attr.step]="config?.step"
    [ngModel]="displayValue"
    [readonly]="readonly"
    [disabled]="disabled"
    (input)="onInputChange($event)"
    (keypress)="onKeyPress($event)"
    (blur)="onTouched()"
  />
</vdr-affixed-input>
